import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu,
  Input, Label, Row, Table } from "reactstrap";
import _ from "lodash";
import { confirmAlert } from "react-confirm-alert";
import { ItemTypeahead, ItemDropdownMenu } from "../index";
import { api, constants, helpers, dateHelpers } from "../../utils";
import { DesktopContainer } from "../../layouts";
import { useGetItemClasses, useGetPrinters } from "../../hooks";
import axios from "axios";
import { toast } from "react-toastify";
import { ColValue } from "./index";
import Select from "react-select";
import { SortHeader, Pager } from "../../components";
import Switch from "react-switch";

const defaultPageSize = 10;

export default function ProductionWorkOrders(props) {
  const { ClassList, Success } = useGetItemClasses({ All: "" });
  const { PrinterList } = useGetPrinters();
  const [classCodeFilter, setClassCodeFilter] = useState({
    value: "-1",
    label: "--- Any ---",
  });
  const [form, setForm] = useState({
    payload: {
      Printer: null,
      ItemNumber: null,
      CasesToProduce: null,
      PrintToPrinter1: true,
    },
    rePrintPayload: {
      Printer: null,
      CaseNumber: null,
      ResetCaseStatus: false,
      PrintToPrinter2: true,
    },
  });
  const [classFunctionList, setClassFunctionList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openOrders, setOpenOrders] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [refresh, setRefresh] = useState(false);
  const [showA, setShowA] = useState(true);
  const [showB, setShowB] = useState(false);
  const [showC, setShowC] = useState(false);
  const [sortDirection, setSortDirection] = useState("asc");
  const [sortField, setSortField] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const printToPrinter = false;
  let alreadyDisplayedList = [];

  useEffect(() => {
    if (!Success) return;
    const list = _.cloneDeep(ClassList);
    if (_.isArray(list)) {
      list.unshift({ value: "-1", label: "--- Any ---" });
      const orderedList = _.orderBy(list, (x) => x.label);
      setClassFunctionList(orderedList);
    } else {
      setClassFunctionList([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ClassList]);

  useEffect(() => {
    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();
    if (showA === false) return;
    setLoading(true);
    api
      .postS(
        "Production/GetProductionWorkOrders",
        createPayload(),
        source.token
      )
      .then((r) => {
        if (!r.data?.success) {
          toast.error(r.data.message);
        } else {
          setOpenOrders(r.data.productionWorkOrders.items);
          setTotalPages(
            _.ceil(r.data.productionWorkOrders.totalCount / pageSize)
          );
        }
      })
      .catch(api.catchHandler)
      .finally(() => {
        setLoading(false);
      });

    return () => {
      source.cancel("axios request cancelled");
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    showA,
    classCodeFilter,
    pageNumber,
    pageSize,
    sortField,
    sortDirection,
    refresh,
  ]);

  function ColPrompt({ title }) {
    return (
      <Col xxl={4}>
        <h5 className="text-end">{title}:</h5>
      </Col>
    );
  }

  const createPayload = () => {
    return {
      ItemClass: helpers.valueFromSelect(classCodeFilter),
      PageSize: pageSize,
      PageNumber: pageNumber,
      SortDirection: sortDirection,
      SortField: sortField,
    };
  };

  const handleCreateWorkOrder = () => {
    let payload = {
      ItemNumber: helpers.valueFromSelect(form.payload.ItemNumber),
      CaseToBuild: parseInt(form.payload.CasesToProduce || "0"),
      PrinterId: form.payload.Printer.value,
      PrinterName: form.payload.Printer.label,
      PrintToPrinter: form.payload.PrintToPrinter1,
    };
    if (payload.PrintToPrinter) {
      api
        .post(`Printer/CreateSingleWorkOrder`, payload)
        .then((response) => {
          if (response && response.data && response.data.success) {
            toast.success("Labels sent to the printer.");
          } else {
            toast.warning(response?.data?.message);
          }
        })
        .catch((error) => {
          api.catchHandler(error);
        });
    } else {
      api
        .postDownloadBinary(
          `Production/CreateWorkSingleOrder`,
          payload,
          constants.MIME_TYPES.pdf,
          `Label_${payload.ItemNumber}_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
          "There was an error downloading the labels, contact your admin."
        )
        .then((res) => {
          if (res?.data === false) {
            toast.error("error creating work order for" + res.message);
          } else {
            toast.success(
              `Work order for item: ${payload.ItemNumber} was created`
            );
          }
        })
        .catch((error) => {
          api.catchHandler(error);
        });
    }
  };

  const handleInputRangeChange = (event, property) => {
    const { value } = event.target;
    if (value === "") {
      onChange(property, value);
      return;
    }
    const regex = /^([0-9]+(\.[0-9]*)?|\.[0-9]+)$/;
    const found = value.match(regex);
    if (found === null) {
      toast.warning(
        `your number ${value} is not formatted correctly please try again`
      );
      return;
    }

    const parsedValue = parseInt(value);
    onChange(property, parsedValue);
  };

  const handleReprintCaseLabel = () => {
    let payload = {
      CaseNumber: form.rePrintPayload.CaseNumber,
      ResetCaseStatus: form.rePrintPayload.ResetCaseStatus,
      PrinterId: form.rePrintPayload.Printer.value,
      PrinterName: form.rePrintPayload.Printer.label,
      PrintToPrinter: form.rePrintPayload.PrintToPrinter2,
    };
    if (payload.PrintToPrinter) {
      api
        .post("Printer/PrintCaseLabel", payload)
        .then((response) => {
          if (response && response.data && response.data.success) {
            toast.success("Labels sent to the printer.");
          } else {
            toast.warning(response?.data?.message);
          }
        })
        .catch(api.catchHandler);
    } else {
      api
        .postDownloadBinary(
          `Production/ReprintCaseLabel`,
          payload,
          constants.MIME_TYPES.pdf,
          `CaseLabels_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
          "There was an error downloading the labels, contact your admin."
        )
        .then((res) => {
          if (res?.data === false) {
            toast.error(res.message);
          } else {
            toast.success("Labels Printed");
          }
        })
        .catch((error) => {
          api.catchHandler(error);
        });
    }
  };

  const onChange = (property, value) => {
    let copy = _.cloneDeep(form);
    _.set(copy, property, value);
    setForm(copy);
  };

  function onPageSizeChange(size) {
    setPageSize(size);
    setTotalPages(1);
    setPageNumber(1);
  }

  function onSortChange(field, direction) {
    if (field !== sortField) {
      setSortField(field);
      setSortDirection("asc");
    } else {
      setSortDirection(direction);
    }
    setPageNumber(1);
  }

  return (
    (document.title = `Production Work Orders`),
    (
      <DesktopContainer screenName={"Production Work Orders"}>
        <div className="filter-header sticky-top">
          <div className="dashboard-button-container">
            <Button
              children={"View Open Orders"}
              className="filter-button"
              onClick={() => setShowA(!showA)}
              active={showA}
            />
            <Button
              children={"Create Item Work Order"}
              className="filter-button"
              onClick={() => setShowB(!showB)}
              active={showB}
            />
            <Button
              children={"Reprint Production Labels"}
              className="filter-button"
              onClick={() => setShowC(!showC)}
              active={showC}
            />
          </div>
        </div>
        {showA ? (
          <Card className="dashboard-card">
            <CardBody>
              <div>
                <span className="h2 me-2">View Open Work Orders</span>
              </div>
              <hr />
              <Row>
                <ColPrompt title={"Item Class"} />
                <ColValue size={3}>
                  <Select
                    classNamePrefix="serviceThreadSelect"
                    options={classFunctionList}
                    value={classCodeFilter}
                    onChange={(opt) => {
                       setClassCodeFilter(opt);
                       setPageNumber(1);
                       }}
                  />
                </ColValue>
              </Row>
              <Row className="mt-5 mb-3">
                <Col
                  xxl={{ offset: 1, size: 10 }}
                  className="transparent-background"
                >
                  <Pager
                    className={"float-end"}
                    callBack={(newPage) => setPageNumber(newPage)}
                    sizeCallback={onPageSizeChange}
                    pageNumber={pageNumber}
                    pageSize={pageSize ? pageSize : null}
                    totalPages={totalPages}
                    downloading={loading}
                    allowAll={false}
                    defaultPageSize={defaultPageSize}
                  />
                </Col>
              </Row>
              <Row>
                <Col xxl={{ offset: 1, size: 10 }}>
                  {showA && openOrders && (
                    <Table size="sm" className="data-table">
                      <thead className="table-header">
                        <tr>
                          <th>
                            <SortHeader
                              displayName="Item #"
                              field="ItemNumber"
                              sortDirection={sortDirection}
                              sorted={sortField === "ItemNumber"}
                              callback={onSortChange}
                            />
                          </th>
                          <th>Work Order</th>
                          <th>Original WO Qty</th>
                          <th>Open Cases</th>
                          <th>Total Open Cases</th>
                        </tr>
                      </thead>
                      <tbody>
                        {_.map(openOrders, (x, index) => {
                          const alreadyDisplayed = _.includes(
                            alreadyDisplayedList,
                            x.itemNumber
                          );
                          alreadyDisplayedList.push(x.itemNumber);
                          return (
                            <tr
                              key={index}
                              className={`tr-${
                                index % 2 === 0 ? "primary" : "secondary"
                              }`}
                            >
                              {alreadyDisplayed ? (
                                <td children={false} />
                              ) : (
                                <ItemDropdownMenu
                                  itemNumber={x.itemNumber}
                                  itemDescription={x.itemWithDesc}
                                  attachmentCount={x.itemAttachmentCount}
                                />
                              )}
                              <WorkOrderDropDownMenu
                                WorkOrder={x}
                                setRefresh={setRefresh}
                                refresh={refresh}
                                printerName={PrinterList[0]?.label || ""}
                                printerId={PrinterList[0]?.value || 0}
                                printToPrinter={printToPrinter}
                              />
                              <td className="data-cell">{x.casesToProduce}</td>
                              <td className="data-cell">
                                {x.openWorkOrderCases}
                              </td>
                              {alreadyDisplayed ? (
                                <td children={false} />
                              ) : (
                                <td className="data-cell">
                                  {x.totalOpenCases}
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
        ) : (
          false
        )}
        {showB ? (
          <Card className="dashboard-card">
            <CardBody>
              <div>
                <span className="h2 me-2">Create Item Work Order</span>
              </div>
              <hr />
              <Row className="mb-2">
                <ColPrompt title={"Item #"} />
                <ColValue size={4}>
                  <ItemTypeahead
                    value={form.payload.ItemNumber}
                    onChange={(e) => onChange("payload.ItemNumber", e)}
                  />
                </ColValue>
              </Row>
              <Row className="mb-2">
                <ColPrompt title={"Cases to Produce"} />
                <ColValue size={4}>
                  <Input
                    type="text"
                    value={form.payload.CasesToProduce || ""}
                    onChange={(e) =>
                      handleInputRangeChange(e, "payload.CasesToProduce")
                    }
                  />
                </ColValue>
              </Row>
              <Row className="mb-2">
                <ColPrompt title={"Printer"} />
                <ColValue size={4}>
                  <Select
                    classNamePrefix="serviceThreadSelect"
                    options={PrinterList}
                    value={form.payload.Printer}
                    onChange={(opt) => onChange("payload.Printer", opt)}
                  />
                </ColValue>
              </Row>
              <Row>
                <ColPrompt title={"Printer Settings"} />
                <ColValue size={4}>
                  <Label style={{ display: "flex", alignContent: "center" }}>
                    <Switch
                      onChange={() =>
                        onChange(
                          "payload.PrintToPrinter1",
                          !form.payload.PrintToPrinter1
                        )
                      }
                      checked={form.payload.PrintToPrinter1}
                      className="react-switch"
                    />
                    <div className="ms-2">
                      {form.payload.PrintToPrinter1
                        ? "Print to printer"
                        : "Download as PDF"}{" "}
                    </div>
                  </Label>
                </ColValue>
              </Row>
              <Row>
                <Col xxl={{ offset: 4, size: 4 }}>
                  <Button
                    className={"shredButton float-end"}
                    children={"Create Work Orders"}
                    onClick={handleCreateWorkOrder}
                    disabled={
                      !form.payload.ItemNumber ||
                      !form.payload.CasesToProduce ||
                      !form.payload.Printer
                    }
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        ) : (
          false
        )}
        {showC ? (
          <Card className="dashboard-card">
            <CardBody>
              <div>
                <span className="h2 me-2">Reprint Production Labels</span>
              </div>
              <hr />
              <Row className="mb-2">
                <ColPrompt title={"Case #"} />
                <ColValue size={4}>
                  <Input
                    type="text"
                    value={form.rePrintPayload.CaseNumber || ""}
                    onChange={(e) =>
                      onChange("rePrintPayload.CaseNumber", e.target.value)
                    }
                  />
                </ColValue>
              </Row>
              <Row className="mb-2">
                <Col xxl={4}>
                  <Input
                    type="checkbox"
                    className="float-end me-2"
                    style={{}}
                    value={form.rePrintPayload.ResetCaseStatus}
                    onChange={() =>
                      onChange(
                        "rePrintPayload.ResetCaseStatus",
                        !form.rePrintPayload.ResetCaseStatus
                      )
                    }
                  />
                </Col>
                <Col xxl={4}>
                  <h5>Reset Case Status to Added to inventory</h5>
                </Col>
              </Row>
              <Row className="mb-2">
                <ColPrompt title={"Printer"} />
                <ColValue size={4}>
                  <Select
                    classNamePrefix="serviceThreadSelect"
                    options={PrinterList}
                    value={form.rePrintPayload.Printer}
                    onChange={(opt) => onChange("rePrintPayload.Printer", opt)}
                  />
                </ColValue>
              </Row>
              <Row>
                <ColPrompt title={"Printer Settings"} />
                <ColValue size={4}>
                  <Label style={{ display: "flex", alignContent: "center" }}>
                    <Switch
                      onChange={() =>
                        onChange(
                          "rePrintPayload.PrintToPrinter2",
                          !form.rePrintPayload.PrintToPrinter2
                        )
                      }
                      checked={form.rePrintPayload.PrintToPrinter2}
                      className="react-switch"
                    />
                    <div className="ms-2">
                      {form.rePrintPayload.PrintToPrinter2
                        ? "Print to printer"
                        : "Download as PDF"}{" "}
                    </div>
                  </Label>
                </ColValue>
              </Row>
              <Row>
                <Col xxl={{ offset: 4, size: 4 }}>
                  <Button
                    className={"shredButton float-end"}
                    children={"Reprint case label"}
                    onClick={handleReprintCaseLabel}
                    disabled={
                      !form.rePrintPayload.CaseNumber ||
                      !form.rePrintPayload.Printer
                    }
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        ) : (
          false
        )}
      </DesktopContainer>
    )
  );
}

function WorkOrderDropDownMenu({
  WorkOrder,
  setRefresh,
  refresh,
  printerName,
  printerId,
  printToPrinter,
}) {
  const [open, setOpen] = useState(false);

  function handleCancelWorkOrder() {
    confirmAlert({
      title: "Cancel Order",
      message: "Are you sure you want to cancel this work order?",
      buttons: [
        {
          label: "Yes",
          onClick: handleCancelWorkOrderFinal,
        },
        {
          label: "No",
        },
      ],
    });
  }

  function handleCancelWorkOrderFinal() {
    api
      .fetch(`Production/CancelWorkOrder/${WorkOrder.workOrderId}`)
      .then((r) => {
        if (r.data.success) {
          toast.success("Successfully canceled the work order");
          setRefresh(!refresh);
        } else {
          toast.error(r.data.message);
        }
      })
      .catch(api.catchHandler)
      .finally(() => {});
  }

  function handleReprintLabelFinal() {
    api
      .postDownloadBinary(
        `Production/ReprintAllLabels`,
        {
          WorkOrderId: WorkOrder.workOrderId,
          PrinterName: printerName,
          PrinterId: printerId,
          // PrintToPrinter, not PrinterToPrinter - the misspelling never bound to the criteria, so the
          // server saw the default false. It reads as harmless because printToPrinter is hardcoded
          // false above anyway, which is exactly what made it survive: nothing changes when it is wrong.
          PrintToPrinter: printToPrinter,
        },
        constants.MIME_TYPES.pdf,
        `Labels_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
        "There was an error downloading the labels, contact your admin."
      )
      .then((res) => {
        if (res?.data === false) {
          toast.error(res.message);
        } else {
          toast.success("Labels Printed");
        }
      })
      .catch((error) => {
        api.catchHandler(error);
      });
  }

  function handleReprintLabels() {
    confirmAlert({
      title: "Reprint Labels",
      message: `Are you sure you want to reprint the production labels for this work order?
          Doing so will cause any existing production labels to become invalid.`,
      buttons: [
        {
          label: "Yes",
          onClick: handleReprintLabelFinal,
        },
        {
          label: "No",
        },
      ],
    });
  }

  return (
    <td
      className="data-cell"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      style={{ position: "relative" }}
    >
      <span className="shredLink fw-bold">{WorkOrder.displayId}</span>
      <Dropdown
        isOpen={open}
        toggle={() => setOpen(!open)}
        style={{ position: "absolute", top: "1.75em", left: "2em" }}
      >
        <DropdownMenu>
          <DropdownItem className="cursor-pointer">
            <a rel="noreferrer"
              href={`${constants.ENDPOINTS.workOrderDetail}/${WorkOrder.workOrderId}`}
              target="_blank"
              className="regularAnchor"
            >
              Workorder Details
            </a>
          </DropdownItem>
          <DropdownItem
            className="cursor-pointer"
            onClick={() => handleReprintLabels()}
          >
            Reprint Production Labels
          </DropdownItem>
          <DropdownItem
            onClick={() => handleCancelWorkOrder()}
            className="sort-handle"
          >
            Cancel Work Order
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </td>
  );
}
